import { useState, useEffect, useCallback } from 'react';
export function useToast() {
    const [toast, setToast] = useState(null);
    useEffect(() => {
        if (!toast)
            return;
        const id = setTimeout(() => setToast(null), 3000);
        return () => clearTimeout(id);
    }, [toast]);
    const showToast = useCallback((message, type = 'success') => {
        setToast({ message, type });
    }, []);
    return { toast, showToast };
}
